import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const RequestContent = styled.div`
    margin-top: 32px;
    position: sticky;
    flex-direction: column;
    width: 100%;
    top: 120px;
    
    &:empty {
       display: none;
    }
`;

export const LeftSide = styled.div`
    flex: 1;
    flex-direction: column;
    display: contents;

    @media (max-width: ${wideBreakpoints.laptop}) {
        flex: 0 1 auto;
        display: flex;
        width: 100%;
    }
`;
